import { render } from "./ButtonDropdown.vue?vue&type=template&id=4debc81a&scoped=true"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"

import "./ButtonDropdown.vue?vue&type=style&index=0&id=4debc81a&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4debc81a"]])

export default __exports__